import React, { useState } from 'react'
import { 
    FaLocationDot,
    FaPhoneFlip,
    FaEnvelope,
    FaCalendar,
    FaFacebookF,
    FaSquareXTwitter,
    FaSnapchat,
    FaTiktok,
    FaAlignJustify,
    FaXmark,
    FaCartShopping 
} from "react-icons/fa6";
import { BiSupport } from "react-icons/bi";

import logo from '../../../Assets/logo.png'
import './Header.css'

const Header = () => {
    const [menuMobile, setMenuMobile] = useState(false)

  return (
    <header>
        <div className='bg-primary py-5 px-5 flex flex-wrap flex-row items-center justify-around vsm:justify-center sm:justify-center md:justify-around'>
            <div className='flex flex-row flex-wrap items-center font-medium mb-0 justify-center vsm:hidden sm:hidden md:hidden lg:flex'>
                <div className='flex flex-row flex-wrap items-center'>
                    <FaLocationDot className='ml-2' />
                    <span>المملكة العريبة السعودية الرياض - ضرما - المنطقة الصناعية</span>
                </div>
                <div className='flex flex-row flex-wrap items-center px-5'>
                    <FaPhoneFlip className='ml-2' />
                    <span>0569526529</span>
                </div>
                <div className='flex flex-row flex-wrap items-center px-5'>
                    <FaEnvelope className='ml-2' />
                    <span>info@granitewatani.com</span>
                </div>
            </div>
            <div className='flex flex-row flex-wrap items-center font-medium justify-center vsm:hidden sm:hidden md:hidden lg:flex'>
                <div className='flex flex-row flex-wrap items-center'>
                    <FaCalendar className='ml-2' />
                    <span>السبت - الخميس 8:00 صباحا - 12:00 مساء</span>
                </div>
                <div className='flex flex-row flex-wrap items-center mr-5'>
                    <a href='#4'>
                        <FaFacebookF  className='ml-5 transition duration-120 delay-150 ease-in-out hover:text-facebook hover:delay-500' />
                    </a>
                    <a href='#1'>
                        <FaSquareXTwitter  className='ml-5' />
                    </a>
                    <a href='#2'>
                        <FaSnapchat  className='ml-5 transition duration-120 delay-150 ease-in-out hover:text-snapchat hover:delay-500' />
                    </a>
                    <a href='#3'>
                        <FaTiktok  className='transition duration-120 delay-150 ease-in-out hover:text-tiktok hover:delay-500' />
                    </a>
                </div>
            </div>
            <div className='flex flex-row justify-center text-center font-bold text-sm items-center vsm:flex sm:flex md:flex lg:hidden'>
                <p>عزيزي العميل للطلبات الخاصة والكميات الكبيرة الرجاء التواصل على الرقم 05388811100 يسعدنا خدمتكم</p>
            </div>
        </div>
        <div className='bg-second py-7 flex flex-wrap flex-row items-center justify-around'>
            <div className='flex items-center gap-5'>
                {
                    menuMobile? (
                        <FaXmark onClick={()=> setMenuMobile(!menuMobile)} className='hidden text-primary text-2xl cursor-pointer vsm:block sm:block md:block lg:hidden ' />
                    ) : (
                        <FaAlignJustify onClick={()=> setMenuMobile(!menuMobile)} className='hidden text-primary text-2xl cursor-pointer vsm:block sm:block md:block lg:hidden' />
                    )
                }
                <a href='/'>
                    <img src={logo} alt='Watani' className='w-28 vsm:w-24 sm:w-24 md:w-24 lg:w-28' />
                </a>
            </div>
            <div className='flex items-center gap-5 vsm:block sm:block md:block lg:hidden'>
                <a href="/تواصل-معنا" className='p-2 border-primary border rounded-full'>
                    <BiSupport className='hidden text-primary text-2xl cursor-pointer' />
                </a>
                <a href="/المنتجات" className='p-2 border-primary border rounded-full vsm:block sm:block md:block lg:hidden'>
                    <FaCartShopping className='hidden text-primary text-2xl cursor-pointer' />
                </a>            </div>
            <div className={menuMobile?  'flex flex-wrap flex-col justify-center fixed top-0 left-0 z-20 bg-black h-screen	w-8/12 transition-all': 'flex flex-wrap flex-row items-center justify-between vsm:hidden sm:hidden md:hidden lg:flex'}>
                <nav>
                    <ul className={menuMobile ? 'flex flex-wrap flex-col px-5' : 'flex flex-wrap flex-row items-center'}>
                        <li className={menuMobile?'relative mb-10':'relative after-effect'}>
                            <a href='/' className='text-white py-5 px-5 transition duration-120 delay-100 ease-in-out hover:text-primary hover:delay-150'>الرئيسية</a>
                        </li>
                        <li className={menuMobile?'relative mb-10':'relative after-effect'}>
                            <a href="/المنتجات" className='text-white py-5 px-5 transition duration-120 delay-100 ease-in-out hover:text-primary hover:delay-150'>المنتجات</a>
                        </li>
                        <li className={menuMobile?'relative mb-10':'relative after-effect'}>
                            <a href="/من-نحن" className='text-white py-5 px-5 transition duration-120 delay-100 ease-in-out hover:text-primary hover:delay-150'>من نحن</a>
                        </li>
                        <li className={menuMobile?'relative mb-10':'relative after-effect'}>
                            <a href="/مشاريعنا" className='text-white py-5 px-5 transition duration-120 delay-100 ease-in-out hover:text-primary hover:delay-150'>المشاريع</a>
                        </li>
                        <li className={menuMobile?'relative mb-10':'relative after-effect'}>
                            <a href='/#success-partners' className='text-white py-5 px-5 transition duration-120 delay-100 ease-in-out hover:text-primary hover:delay-150'>شركاء النجاح</a>
                        </li>
                    </ul>
                </nav>
                <a href="/تواصل-معنا" className={menuMobile? 'text-black relative z-0 bg-primary py-3 px-7 btn-contact': 'text-black relative z-0 mr-10 bg-primary py-3 px-7 btn-contact'}>
                    <button className='relative z-10'>تواصل معنا</button>
                </a>
            </div>
        </div>
    </header>
  )
}

export default Header